// extracted by mini-css-extract-plugin
export var assetCell = "da67Plbfo9pGxY7_i4JY";
export var assetCellLogo = "vfOS8LigImpPIl_BU6bV";
export var assetCellTicker = "V43T9ZRSMDGW3khlUKGX";